@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'Third Party'"
        [moduleLabel]="'overview.workspaceModuleLabel' | t"
        [moduleLabelPlural]="'overview.workspaceModuleLabelPlural' | t"
        [moduleType]="moduleType"
        [idProp]="'Guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="openThirdParty($event)"
        (onAddClick)="addThirdParty()"
    >
    </cerrix-workspace>
}
